import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import ProductListProvider from './ProductListProvider';
import ProductList from './ProductList';
import { Helmet } from 'react-helmet-async';
import TopBar from '../common/TopBar';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    header: {
        marginBottom: theme.spacing(3),
    }
}));

const Products = () => {
    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <Helmet>
                <title>Riverside Takeoffs :: Products List</title>
            </Helmet>
            <TopBar isLoggedIn={true} title="Products"/>
            <div className={classes.header}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Products
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Browse all available products in the system
                </Typography>
            </div>
            
            <ProductListProvider>
                <ProductList />
            </ProductListProvider>
        </Container>
    );
};

export default Products;
